import * as z from "zod";

import { FocusAreaSchema } from "@/domain/focus-area/models/focus-area-schema";
import { UnitSchema } from "@/domain/key-result/models/key-result-schema";
import { LabelSchema } from "@/domain/label/models/label.schema";
import { LabelGroupSchema } from "@/domain/label/models/label-group.schema";
import { PhaseSchema } from "@/domain/phase/models/phase.schema";
import { PrioritySchema } from "@/domain/priority/models/priority.schema";
import { WorkspaceMembershipSchema } from "@/domain/user/models/current-user-model";

export const WorkspaceSchema = z.object({
  id: z.string(),
  name: z.string(),
  workspaceUrl: z.string(),
  logo: z.string().nullable().optional(),
  updatedAt: z.string(),
  createdAt: z.string(),
  priorityList: z.array(PrioritySchema).nullable().optional(),
  phaseList: z.array(PhaseSchema).nullable().optional(),
  unitList: z.array(UnitSchema).nullable().optional(),
  focusAreaList: z.array(FocusAreaSchema).nullable().optional(),
  labelList: z.array(LabelSchema).nullable().optional(),
  labelGroupList: z.array(LabelGroupSchema).nullable().optional(),
  workspaceMembershipList: z.array(WorkspaceMembershipSchema).nullable().optional(),
});

export type Workspace = z.infer<typeof WorkspaceSchema>;
